// =============================================================================
// HOOKS/USEAMBIENTE.TS — Rótulo do ambiente + estado da conexão iSolve
// =============================================================================
// Lê GET /api/ambiente (endpoint PÚBLICO, sem auth) uma vez ao montar. Serve ao
// banner de ambiente do AppShell: quando `isolveConectado=false` (só no backend
// de HML, via ISOLVE_CONEXAO_HABILITADA=false), a topbar vermelha aparece.
// Falha silenciosa: sem o endpoint, nada de banner (ambiente permanece null).
// =============================================================================

import { useEffect, useState } from 'react';

export interface AmbienteInfo {
  ambiente: string | null;
  isolveConectado: boolean;
}

export function useAmbiente(): AmbienteInfo | null {
  const [ambiente, setAmbiente] = useState<AmbienteInfo | null>(null);

  useEffect(() => {
    let cancelado = false;
    const base = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';
    fetch(`${base}/api/ambiente`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d: AmbienteInfo | null) => {
        if (!cancelado && d) setAmbiente(d);
      })
      .catch(() => {
        /* silencioso — sem /api/ambiente, nenhum banner */
      });
    return () => {
      cancelado = true;
    };
  }, []);

  return ambiente;
}
